module.exports = __webpack_public_path__ + "static/media/nucleo-outline.22a0bffe.ttf";